// extracted by mini-css-extract-plugin
export default {"root":"Spinner_root__LiP8l","small":"Spinner_small__k7+2h","spinner":"Spinner_spinner__IONmK","spinnerFixed":"Spinner_spinnerFixed__xhUUF"};